import { z } from 'zod';

export const platform = z.union([
  z.literal('ios'),
  z.literal('android'),
  z.literal('windows'),
  z.literal('macos'),
  z.literal('web'),
]);

export type Platform = z.infer<typeof platform>;
